import React from "react";
import PageLayout from "./PageLayout";
import Gallery from "../sections/Gallery";

export default function GalleryPage() {
    return (
        <PageLayout testId="gallery-page" pageTitle="Qalereya">
            <Gallery standalone />
        </PageLayout>
    );
}
